import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './PlanTitleLoading.Config.Styles';

const titleLoadingConfig = withRightView => [
  {
    left: setLoadingConfigObject('square', 1, 174, styles.headerStyle({ width: 174 })),
    ...(withRightView && {
      right: setLoadingConfigObject(
        'square',
        1,
        null,
        styles.headerStyle({ width: 80, height: 16 }),
      ),
    }),
  },
  {
    ...(!withRightView && {
      left: setLoadingConfigObject(
        'square',
        1,
        null,
        styles.headerStyle({ width: 80, height: 16 }),
      ),
    }),
  },
];

export { titleLoadingConfig, shimmerPlaceholderConfig };
